import React, { createContext } from "react";

import { FeedV2 } from "@fartherfinance/frontend/api/Notifications/Types";

import AddTask from "@src/assets/svg/addTask";
import NotificationsActive from "@src/assets/svg/notificationsActive";
import Text from "@src/sharedComponents/Typography/Text";
import { pluralize } from "@src/utils/pluralize";

import styles from "./NotificationPreview.module.css";

export const SelectedNotificationContext = createContext<FeedV2 | undefined>(
  undefined
);

interface NotificationPreviewProps {
  selectedNotification: FeedV2 | undefined;
  unreadCount: number | undefined;
}

const NotificationPreview: React.FC<
  React.PropsWithChildren<NotificationPreviewProps>
> = ({ children, selectedNotification, unreadCount = 0 }) => {
  if (selectedNotification) {
    return (
      <SelectedNotificationContext.Provider value={selectedNotification}>
        {children}
      </SelectedNotificationContext.Provider>
    );
  }

  if (unreadCount > 0) {
    return (
      <div className={styles.container}>
        <NotificationsActive className={styles.icon} />
        <Text variant="title2" color="textSubtle">
          {pluralize(unreadCount, "Unread Notification", true)}
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <AddTask className={styles.icon} />
      <Text variant="title2" color="textSubtle">
        You're all caught up.
      </Text>
    </div>
  );
};

export default NotificationPreview;
